import { createAsyncThunk } from "@reduxjs/toolkit";
import jobPostApi from "api/jobPostApi";
import { formatQueryParams } from "helpers/format";

export const getJobPosts = createAsyncThunk("JobPosts", async (params: any = {}) => {
  try {
    const response = await jobPostApi.jobPosts(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const getJobPostDetail = async (id: string | number) => {
  try {
    const response = await jobPostApi.getJobPostDetail(id);
    return response;
  } catch (error) {
    return error;
  }
};


export const createJobPost = async (data: any = {}) => {
  try {
    const response = await jobPostApi.postJobPost(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const updateJobPost = async (id: string | number, data: any = {}) => {
  try {
    const response = await jobPostApi.putJobPost(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
